export function LayerItemEmpty() {
  return (
    <div
      className="pointer-events-auto absolute flex items-center justify-center bg-black-black/50 outline outline-2 outline-orange"
      style={{
        width: 100,
        height: 100,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      请添加图片
    </div>
  );
}

export default LayerItemEmpty;
